import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { AdminShipmentSizeType } from '../../enums/admin-shipment-size-type';
import { Nillable } from '@web/utils';
import { dateSerializer } from '@web/common';
import { AdminOrderShipmentItemRequest } from './admin-order-shipment-item.request';

@jsonObject
export class AdminCreateAdditionalShipmentRequest {
  @jsonMember(String)
  public readonly packageSize!: AdminShipmentSizeType;

  @jsonMember(Date, { serializer: dateSerializer() })
  public readonly scheduledShippingDate?: Nillable<Date>;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly boxes?: Nillable<AdminOrderShipmentItemRequest[]>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly products?: Nillable<AdminOrderShipmentItemRequest[]>;

  @jsonArrayMember(AdminOrderShipmentItemRequest)
  public readonly cosmetics?: Nillable<AdminOrderShipmentItemRequest[]>;

  public constructor(
    private readonly data: {
      size: AdminShipmentSizeType;
      scheduledShippingDate?: Nillable<Date>;
      comment?: Nillable<string>;
      boxes?: Nillable<AdminOrderShipmentItemRequest[]>;
      products?: Nillable<AdminOrderShipmentItemRequest[]>;
      cosmetics?: Nillable<AdminOrderShipmentItemRequest[]>;
    },
  ) {
    this.packageSize = this.data.size;
    this.scheduledShippingDate = this.data.scheduledShippingDate;
    this.comment = this.data.comment;
    this.boxes = this.data.boxes;
    this.products = this.data.products;
    this.cosmetics = this.data.cosmetics;
  }
}
